import { useState } from 'react'

import { useMutation } from '@percent/utility'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { APIErrorHandler } from '@percent/admin-dashboard/common/library/APIErrorHandler'
import { InviteUserModalState, UseInviteUserModalReturn, UseInviteUserModalParams } from './useInviteUserModal.types'

export function useInviteUserModal({ onSuccess }: UseInviteUserModalParams = {}): UseInviteUserModalReturn {
  const { accountService } = useServices()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalState, setModalState] = useState<InviteUserModalState | undefined>(undefined)
  const [errorMessage, setErrorMessage] = useState<string>('')

  const [, { mutateAsync: inviteUser }] = useMutation(
    accountService.inviteUser,
    () => {
      setModalState('success')
      onSuccess?.()
    },
    (error: any) => {
      setModalState('error')
      setErrorMessage(APIErrorHandler(error?.response?.data?.error))
    }
  )

  const openModal = () => {
    setIsModalOpen(true)
    setModalState(undefined)
    setErrorMessage('')
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setModalState(undefined)
    setErrorMessage('')
  }

  const confirmInviteUser = async ({
    email,
    fullName,
    employeeType
  }: {
    email: string
    fullName: string
    employeeType: string
  }) => {
    try {
      await inviteUser({ email, fullName, employeeType })
    } catch (err) {
      // Error is handled by the mutation's onError callback
      // No need to do anything here
    }
  }

  return {
    isModalOpen,
    modalState,
    errorMessage,
    openModal,
    closeModal,
    confirmInviteUser
  }
}
